import { ProductState } from './State';

export const getEstimationPreviousCursor = (state: ProductState): string | undefined =>
    state.estimationProductsCursors[state.estimationProductCursorIndex - 1];

export const getEstimationCurrentCursor = (state: ProductState): string | undefined =>
    state.estimationProductsCursors[state.estimationProductCursorIndex];

export const getEstimationNextCursor = (state: ProductState): string | undefined =>
    state.estimationProductsCursors[state.estimationProductCursorIndex + 1];

export const getOrderPreviousCursor = (state: ProductState): string | undefined =>
    state.orderProductsCursors[state.orderProductsCursorIndex - 1];

export const getOrderCurrentCursor = (state: ProductState): string | undefined =>
    state.orderProductsCursors[state.orderProductsCursorIndex];

export const getOrderNextCursor = (state: ProductState): string | undefined =>
    state.orderProductsCursors[state.orderProductsCursorIndex + 1];



// WEBPACK FOOTER //
// ./src/application/products/selector.ts